import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { SuspendedBillsMaster } from "./SuspendedBillsMaster";

const SuspendedBillManagementRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url }
}) => (
  <Switch>
    <Route exact path={`${url}/`} render={() => <SuspendedBillsMaster />} />
  </Switch>
);

export const SuspendedBillManagement = withRouter(SuspendedBillManagementRoutes);